import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * ReferralRedirect — short link handler for finly.uno/r/:code
 *
 * Captura el código de referido en la URL y redirige a /early con el
 * código pre-cargado en el query param ?ref=. Pensado para compartir
 * en WhatsApp/Twitter sin URLs largas.
 */
export default function ReferralRedirect() {
  const { code } = useParams();
  const safeCode = (code || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 24);

  if (!safeCode) {
    return <Navigate to="/early" replace />;
  }

  return <Navigate to={`/early?ref=${safeCode}`} replace data-testid="referral-redirect" />;
}
